import { render, staticRenderFns } from "./ProcedureDetailsShow.vue?vue&type=template&id=65f06764&"
import script from "./ProcedureDetailsShow.vue?vue&type=script&lang=js&"
export * from "./ProcedureDetailsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports